<template>
    <div class="w3-row">
        <div class="w3-left zero-left">
            <h3 class="flow-blue-color zero-top w3-margin-right w3-animate-opacity">{{$t("activeRooms")}}:</h3>
        </div>
        <div class="flow-margin-top-8">
            <span v-if="myRooms.length === 0">{{$t("noRoomsLinked")}}</span>
            <router-link v-else v-for="room in myRooms" :key="room.id" :to="{name: 'room', params: {roomId: room.id}}" :title="room.displayName">
                <span class="consultation-room flow-btn w3-round-medium font-weight-bold w3-margin flow-padding cursor-pointer">
                    {{room.displayName}}
                </span>
            </router-link>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Loading from "../common/Loading";
    import {EventBus} from "../../main";

    let frc = Vue.prototype.$frc;

    export default {
        name: "ActiveRooms",
        components: {Loading},
        props: ['physicians'],
        data: function(){
            return{
                myRooms: [],
                wardId: Vue.prototype.$currentWard.id
            }
        },
        mounted() {
            this.populateRooms();
            EventBus.$on("roomChanged", this.populateRooms);
        },
        beforeDestroy() {
            EventBus.$off("roomChanged", this.populateRooms);
        },
        methods: {
            populateRooms () {
                for (let i in this.physicians) {
                  let physician = this.physicians[i];
                  if (physician.ward.id !== this.wardId) continue;
                  if (physician.rooms) {
                    this.myRooms.push(...physician.rooms);
                  }
                }
            }

        }
    }
</script>